import React from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import * as SettingsActionCreators from 'actions/settings';
import { MessageVia } from 'services/SettingsService';
import { IAppState } from 'types/app';

type State = {
  selectedMethod: MessageVia | undefined,
}

class MessageMethod extends React.Component<Props, State> {
  state: State = {
    selectedMethod: 'None',
  };

  componentWillMount = () => {
    const { data } = this.props;
    this.setState({
      selectedMethod: data.messageViaNetwork,
    });
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { selectedMethod } = this.state;

    if (!selectedMethod) {
      return;
    }

    dispatch(SettingsActionCreators.saveMessageVia(selectedMethod));
  };

  handleChange = (e: any) => {
    this.setState({
      selectedMethod: e.target.value,
    });
  };

  render() {
    const { isChangingVia, data } = this.props;
    const { selectedMethod } = this.state;

    return (
      <div>
        <h2 className="heading heading--2">How should we message you?</h2>
        <form onSubmit={this.handleSubmit}>
          <ul>
            <li className="radio">
              <label>
                <input
                  name="messageVia"
                  type="radio"
                  value="Email"
                  onChange={this.handleChange}
                  checked={selectedMethod === 'Email'}
                />
                {' '}
                Email
              </label>
            </li>
            {data.facebookAuth ? (
              <li className="radio">
                <label>
                  <input
                    name="messageVia"
                    type="radio"
                    value="Facebook"
                    onChange={this.handleChange}
                    checked={selectedMethod === 'Facebook'}
                  />
                  {' '}
                  Facebook
                </label>
              </li>
            ) : null}
            {data.twitterAuth ? (
              <li className="radio">
                <label>
                  <input
                    name="messageVia"
                    type="radio"
                    value="Twitter"
                    onChange={this.handleChange}
                    checked={selectedMethod === 'Twitter'}
                  />
                  {' '}
                  Twitter
                </label>
              </li>
            ) : null}
          </ul>
          <p>
            <button
              className="button button--primary"
              disabled={!selectedMethod}
              type="button"
            >
              {isChangingVia ? 'Saving...' : 'Update'}
            </button>
          </p>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState) => ({
  isChangingVia: state.settings.isChangingVia,
  data: state.settings.data,
});

type Props = RouteComponentProps & ReturnType<typeof mapStateToProps> & {
  dispatch: Function,
};

export default withRouter(connect(mapStateToProps)(MessageMethod));
